import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const EditPencil: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    width={135}
    height={119}
    viewBox="0 0 135 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_965_17776"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="135"
      height="119"
    >
      <path d="M134.678 0H0V118.526H134.678V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_965_17776)">
      <path
        d="M63.9022 106.452C84.3918 106.452 101.002 105.938 101.002 105.305C101.002 104.672 84.3918 104.158 63.9022 104.158C43.4126 104.158 26.8025 104.672 26.8025 105.305C26.8025 105.938 43.4126 106.452 63.9022 106.452Z"
        fill="#80DFEA"
      />
      <path
        d="M92.1865 27.8391C92.1865 27.8391 100.04 40.0605 96.1427 47.569C93.8419 52.004 91.0478 53.6668 87.7089 53.4379C84.3677 53.2091 79.9369 49.3369 77.7109 46.8006C75.485 44.2643 88.6559 22.3672 88.6559 22.3672L92.1865 27.8391Z"
        fill="#B86121"
      />
      <path
        d="M92.1869 27.8411L89.519 23.7051L83.0166 39.7683C83.8139 41.737 84.8123 44.5583 85.4647 47.6691C92.6101 46.9054 96.9194 40.0649 96.9194 40.0649L96.9918 39.9271C96.0051 33.7849 92.1869 27.8411 92.1869 27.8411Z"
        fill="#984F19"
      />
      <path
        d="M81.7564 36.9297C81.7564 36.9297 89.9166 52.9532 84.0104 62.0591C81.1765 66.4287 77.0871 68.8529 72.8877 67.9094C68.6884 66.9658 65.3705 63.117 63.0323 59.4667C60.6942 55.8164 70.7249 40.5146 70.7249 40.5146L81.7564 36.9297Z"
        fill="#D28960"
      />
      <path
        d="M71.7605 67.5804L72.4292 67.7952C72.4386 67.7976 72.4456 67.7999 72.4526 67.8022L82.4202 47.6147C83.2105 47.7338 84.0663 47.7735 84.9992 47.7081C85.1559 47.6964 85.3102 47.6824 85.4645 47.6661C84.8098 44.5576 83.8114 41.7364 83.0164 39.7676L71.7605 67.5804Z"
        fill="#B86121"
      />
      <path
        opacity="0.54"
        d="M81.7562 36.9294C81.7562 36.9294 83.1708 39.711 84.396 43.6112L92.1844 27.8376L88.6561 22.3633C88.6561 22.3633 83.8044 30.4322 80.4866 37.3405L81.7562 36.9294Z"
        fill="#B86121"
      />
      <path
        d="M89.311 -19.0739C89.311 -19.0739 82.6869 1.96144 82.1398 3.99327C81.5927 6.02511 77.2226 19.2087 76.3575 21.7543C75.4924 24.3 72.4855 31.4511 69.5441 33.901C66.6027 36.3509 62.8125 40.1716 58.9124 39.1837C55.0124 38.1959 52.0406 38.0184 50.1279 36.1243C48.2153 34.2303 46.1344 28.1324 46.27 22.7796C46.4991 13.7227 52.3819 -4.22516 52.3819 -4.22516L62.3472 -36.7812L89.311 -19.0739Z"
        fill="#D28960"
      />
      <path
        d="M78.7141 -60.5391L33.2905 59.7503C33.2905 59.7503 40.8662 57.5737 52.7862 61.8732C64.7061 66.1728 69.4012 73.4033 69.4012 73.4033L118.021 -46.7226L78.7141 -60.5391Z"
        fill="#FF612B"
      />
      <path
        d="M69.4035 73.4055L36.571 105.093L33.2905 59.7502C33.2905 59.7502 40.8662 57.5735 52.7862 61.8731C64.7061 66.1726 69.4035 73.4055 69.4035 73.4055Z"
        fill="#FAF8F2"
      />
      <path
        d="M67.879 73.3798L64.4629 70.1008C59.188 66.7471 58.3509 69.2554 56.0829 72.6698L45.3928 89.3566C45.3928 89.3566 47.3452 89.9077 47.7333 91.1292C48.1215 92.353 48.4792 92.2899 48.4792 92.2899L67.879 73.3798Z"
        fill="#FDEDBF"
      />
      <path
        d="M42.6665 90.7084C37.726 91.6472 37.7728 89.0129 35.4463 89.5547L36.5686 105.092L44.6166 90.6664C44.0765 90.5613 43.4381 90.5613 42.6665 90.7084Z"
        fill="#002677"
      />
      <path
        d="M44.6166 90.666L36.5686 105.092L48.1659 93.8983C47.1675 92.6044 46.4544 91.021 44.6166 90.666Z"
        fill="#000C44"
      />
      <path
        d="M37.8266 59.2108L83.1075 -58.9626L78.7141 -60.5391L33.2905 59.7503C33.2905 59.7503 34.9296 59.2809 37.8803 59.2085C37.864 59.2108 37.8453 59.2108 37.8266 59.2108Z"
        fill="#F5B700"
      />
      <path
        d="M37.8267 59.2117C39.6785 59.1626 42.0494 59.2724 44.8645 59.7558L90.0987 -56.5376L83.1193 -58.9922L37.8267 59.2117Z"
        fill="#FF9132"
      />
      <path
        d="M69.4036 73.4061L69.4059 73.4038L118.026 -46.7198L105.928 -50.9727L59.5015 64.9565C66.509 68.9501 69.4013 73.4038 69.4036 73.4061Z"
        fill="#EB4600"
      />
      <path
        d="M100.474 -16.4863C100.474 -16.4863 98.6896 -7.93627 96.4006 -3.59701C94.1115 0.742242 84.4736 8.4025 79.4559 12.8071C71.2349 20.0237 64.861 33.3894 71.2255 42.1263C78.9695 52.7573 90.9222 43.8405 102.987 31.6051C115.534 18.8816 125.658 9.54453 126.921 3.16877C128.183 -3.20933 129.266 -6.63543 129.266 -6.63543L100.474 -16.4863Z"
        fill="#EDB782"
      />
      <path
        d="M97.9624 30.2168C96.466 27.8557 91.5932 22.4281 86.793 22.7714C81.9927 23.1147 73.933 30.1468 73.1451 36.4221C72.633 40.5068 76.353 46.642 80.197 47.0017C87.7282 47.707 93.8379 40.2943 95.7902 38.5427C97.7426 36.7934 100.167 33.6966 97.9624 30.2168Z"
        fill="#FFDAAB"
      />
    </g>
  </Box>
)
export default EditPencil
